import { APP_INITIALIZER, NgModule } from '@angular/core';
import { ComunModule } from './comun.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MissingTranslationHandler,
  TranslateLoader,
  TranslateModule,
} from '@ngx-translate/core';
import { ImportTranslateLoader } from './import-translate-loader';
import { EmptyStringMissingTranslationHandler } from './empty-string-missing-translation-handler';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { AppConfigService } from './services/app-config.service';
import { APP_BASE_HREF, PlatformLocation } from '@angular/common';

function CaseInsensitiveBaseHrefFactory(platformLocation: PlatformLocation): string {
  const path = platformLocation.pathname;
  const baseHrefFromDOM = platformLocation.getBaseHrefFromDOM();  // Get baseHref from Dom and remove start and end backslash.
  const baseHref = baseHrefFromDOM.replace(/(^\/*|\/*$)/g, '');  // Case-insensitive match baseHref in the path ignoring start backslash.
  const caseInSensitiveBaseHrefRegexp = new RegExp(`^\/*${baseHref}`, 'i');
  const matchedBaseHref = path.match(caseInSensitiveBaseHrefRegexp);

 if (matchedBaseHref) {
    const remainingPath = path.slice(matchedBaseHref[0].length);
    // Deal with case which contains basePath but should not use matchedBaseHref. Eg: base = 'base', path='BaseBall'.
    // matchedBaseHref is the end of the path or follows with white space or a new segment which starts with backslash.
    const isValidMatch = !remainingPath || !!remainingPath.match(/^[\/\s]/);
    const result = isValidMatch ? matchedBaseHref[0] : baseHrefFromDOM;
    return result;
  }
  return baseHrefFromDOM;
}

const appInitializerFn = (appConfig: AppConfigService) => {
  return () => appConfig.loadAppConfig();
};
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: ImportTranslateLoader,
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: EmptyStringMissingTranslationHandler,
      },
    }),
    ComunModule.forRoot(),
    ScrollToModule.forRoot(),
    AppRoutingModule,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService],
    },
    {
      provide: APP_BASE_HREF,
      useFactory: CaseInsensitiveBaseHrefFactory,
      deps: [PlatformLocation],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
